import { LegacyEpisodePlayerBaseInfoContent } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

export function getEpisodeTvSeries(episode: LegacyEpisodePlayerBaseInfoContent) {
    return episode.tvSeries;
}
